import { useEffect, useState } from "react";
import { getTodayRate } from "../../services/http";

export default function GoldExchangeRate() {
    const [exData, setExData] = useState('');

    useEffect(() => {
        getTodayRate()
            .then((data) => {
                setExData(data);
            })
    }, []);

    function getDate() {
        const today = new Date();
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear() + 543;
        const date = today.getDate().toString().padStart(2, '0');
        return `${date}/${month}/${year}`;
    }

    return (

        <div style={{ padding: "0 25px 0 25px" }}>
            <div className="card" style={{ maxWidth: "600px", margin: "auto", border: "1px solid #d3bd7a" }}>
                <div className="card-header" style={{ background: "linear-gradient(140deg, #d3bd7a 60%, #ffe69c 100%)", textAlign: "center" }}>
                    <b>ราคาทองวันที่ {'\u00A0'} {getDate()}</b>
                </div>
                <div className="card-body">
                    <div className="row col-12">
                        <div className="column col-6 text-center"><b>ขายออก</b></div>
                        <div className="column col-6 text-center">
                            {exData.full && exData.full.goldbar && exData.full.goldbar.sale ?
                                <span><b>{exData.full.goldbar.sale}</b></span> : <span></span>}
                        </div>
                    </div>
                    <div className="row col-12">
                        <div className="column col-6 text-center"><b>รับซื้อ</b></div>
                        <div className="column col-6 text-center">
                            {exData.full && exData.full.goldbar && exData.full.goldbar.buy ?
                                <span><b>{exData.full.goldbar.buy}</b></span> : <span></span>}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}